// @system — the platform this product is built and hosted on.
//
// White-label rule (Rui, 2026-09-21): a customer's product wears the customer's brand only —
// sidebar, top bar, auth pages, emails all read brand.json through @/config `info`. The platform
// is named in exactly one place per surface: a small "Powered by …" line in the footer (app
// sidebar footer and the landing footer's legal bar). Nothing else in the UI names the platform.
//
// Not overridable from @custom on purpose: the attribution is part of the hosting agreement, and
// this file is refreshed by template sync.
export const platform = Object.freeze({
  name: 'Orkosi',
  url: 'https://orkosi.com',
})

export const poweredByLabel = `Powered by ${platform.name}`
